import { postNamedQuery } from '../../../../../../service'

export default async function getThingData (slotData, levelTypeId, levelId) {
  const categoryCode = slotData?.data?.categoryCode ?? 'lifePlan'
  const [schema, things] = await Promise.all([
    await postNamedQuery('levels', 'get-thing-schema', {
      levelTypeId,
      levelId
    }),
    await postNamedQuery('levels', 'get-things', {
      levelTypeId,
      levelId
    })
  ])
  const schemaThings = schema?.data?.schema?.find(({ code }) => code === categoryCode)?.things ?? []

  return schemaThings.map((schemaThing) => {
    const matchingThing = things?.data?.things?.find(t => t.code === schemaThing.code) || {}

    return {
      ...schemaThing,
      ...matchingThing,
      ...(matchingThing && {
        levelId: matchingThing.thingId,
        levelTypeId: 279
      }),
      entityLevelTypeId: 279,
      label: matchingThing?.name ?? schemaThing.name,
      description: matchingThing?.content ?? schemaThing.description,
      id: matchingThing?.thingId ?? schemaThing.code,
      schema: schemaThing
    }
  })
}
